export const baseUrl = process.env.REACT_APP_KEYCLOAKAPI_URL;
//export const baseUrl = "http://localhost:8005/services/keycloakapi";

export const keycloakapiUrls = {
    users: () => `${baseUrl}/users/`,
    roles: () => `${baseUrl}/roles/`,
    permissions: () => `${baseUrl}/permissions/`
};
